import { createAction } from '@reduxjs/toolkit';

export const mapUpdateId = createAction('map/updateId');
export const mapUpdateUID = createAction('map/updateUID');
export const mapUpdateSID = createAction('map/updateSID');
export const mapUpdateIsAdded = createAction('map/updateIsAdded');
export const mapUpdateIsActive = createAction('map/updateIsActive');

export const mapStore = createAction('map/store');
export const mapClear = createAction('map/clear');

export const mapUpdateRequesting = createAction('map/mapUpdateRequesting');
export const mapUpdateRequest = createAction('map/updateRequest');
export const mapUpdateError = createAction('map/updateError');
export const mapUpdateStore = createAction('map/updateStore');

export const mapUpdateCode = createAction('map/updateCode ');
export const mapUpdateIsFullWidth = createAction('map/updateIsFullWidth');

export const mapUpdateView = createAction('map/updateView');
export const mapUpdateAddress = createAction('map/updateAddress');
export const mapUpdateAddressLink = createAction('map/updateAddressLink');
export const mapUpdateAddressButtonText = createAction('map/updateAddressButtonText');
export const mapUpdateAddressIconType = createAction('map/updateAddressIconType');
export const mapUpdateAddressList = createAction('map/updateAddressList');
export const mapUpdateAddressTitle = createAction('map/updateAddressTitle');

export const mapUpdateHeadingTitle = createAction('map/updateHeadingTitle');
export const mapUpdateHeadingDescription = createAction('map/updateHeadingDescription');
export const mapUpdateHeadingTextAlign = createAction('map/updateHeadingTextAlign');
export const mapUpdateHeadingImage = createAction('map/updateHeadingImage');
export const mapUpdateHeadingDivider = createAction('map/updateHeadingDivider');

export const mapUpdateSectionIsBackground = createAction('map/updateSectionIsBackground');
export const mapUpdateSectionTextColor = createAction('map/updateSectionTextColor');
export const mapUpdateSectionBackgroundColor = createAction('map/updateSectionBackgroundColor');
export const mapUpdateSectionOpacity = createAction('map/updateSectionOpacity');
export const mapUpdateSectionIsFullWidth = createAction('map/updateSectionIsFullWidth');
export const mapUpdateSectionShadow = createAction('map/updateSectionShadow');
export const mapUpdateSectionShadowColor = createAction('map/updateSectionShadowColor');
export const mapUpdateSectionPadding = createAction('map/updateSectionPadding');
export const mapUpdateSectionMargin = createAction('map/updateSectionMargin');
export const mapUpdateSectionBackgroundType = createAction('map/updateSectionBackgroundType');
export const mapUpdateSectionBackgroundImage = createAction('map/updateSectionBackgroundImage');
export const mapUpdateSectionGradientColor1 = createAction('map/updateSectionGradientColor1');
export const mapUpdateSectionGradientColor2 = createAction('map/updateSectionGradientColor2');
export const mapUpdateSectionGradientDirection = createAction('map/updateSectionGradientDirection');
export const mapUpdateSectionGradientOffset = createAction('map/updateSectionGradientOffset');
export const mapUpdateSectionBorder = createAction('map/updateSectionBorder');
export const mapUpdateSectionBorderColor = createAction('map/updateSectionBorderColor');
export const mapUpdateSectionShadowBorderColor = createAction('map/updateSectionShadowBorderColor');
export const mapUpdateSectionShape = createAction('map/updateSectionShape');

export const mapUpdateButtonText = createAction('map/updateButtonTitle');
export const mapUpdateButtonBackgroundColor = createAction('map/updateButtonBackgroundColor');
export const mapUpdateButtonTextColor = createAction('map/updateButtonTextColor');
export const mapUpdateButtonOpacity = createAction('map/updateButtonOpacity');
export const mapUpdateButtonBorder = createAction('map/updateButtonBorder');
export const mapUpdateButtonBorderColor = createAction('map/updateButtonBorderColor');
export const mapUpdateButtonShadow = createAction('map/updateButtonShadow');
export const mapUpdateButtonShadowColor = createAction('map/updateButtonShadowColor');
export const mapUpdateButtonShape = createAction('map/updateButtonShape');

export const mapUpdateItemShadow = createAction('map/updateItemShadow');
export const mapUpdateItemShadowColor = createAction('map/updateItemShadowColor');
export const mapUpdateItemBorder = createAction('map/updateItemBorder');
export const mapUpdateItemBorderColor = createAction('map/updateItemBorderColor');
export const mapUpdateItemShape = createAction('map/updateItemShape');
export const mapUpdateItemTextColor = createAction('map/updateItemTextColor');
export const mapUpdateItemBackgroundColor = createAction('map/updateItemBackgroundColor');
